import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { VERSION, MODE, CONTENT_BASE, MEDIA_BASE, BACKOFFICE_URL } from './Settings';

@customElement('lindberg-debug')
export class Debug extends LitElement {
	constructor() {
		super();
		console.log({debug: import.meta.env})
	}
	render() {
		return html`
		<div style="display: none;">
			<div>Version: ${VERSION}</div>
			<div>Mode: ${MODE}</div>
			<div>Content Base: ${CONTENT_BASE}</div>
			<div>Media Base: ${MEDIA_BASE}</div>
			<div>Backoffice Url: ${BACKOFFICE_URL}</div>
			<div>API Base: ${import.meta.env.VITE_API_BASE}</div>
		</div>
		`
	}
}
